if (!customElements.get('ss-commitments')) {
  customElements.define('ss-commitments', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-ss-rail]');
      if (!this.rail || this.dataset.sliderMobile === 'false') return;

      this.prev = this.querySelector('[data-ss-prev]');
      this.next = this.querySelector('[data-ss-next]');
      this.dotsEl = this.querySelector('[data-ss-dots]');
      this.slides = Array.from(this.rail.children);
      if (this.slides.length < 2) return;

      this.cleanup = [];
      this.onScroll = SS.rafThrottle(this.update.bind(this));

      // Activation mobile uniquement
      this.cleanup.push(
        SS.onBreakpoint(
          `(max-width: ${SS.bp.desktop - 1}px)`,
          () => this.enable(),
          () => this.disable()
        )
      );
    }

    disconnectedCallback() {
      this.disable();
      this.cleanup?.forEach((fn) => fn());
    }

    enable() {
      if (this.active) return;
      this.active = true;

      this.prev?.removeAttribute('hidden');
      this.next?.removeAttribute('hidden');
      this.prevHandler = () => this.go(-1);
      this.nextHandler = () => this.go(1);
      this.prev?.addEventListener('click', this.prevHandler);
      this.next?.addEventListener('click', this.nextHandler);

      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.buildDots();
      this.update();
    }

    disable() {
      if (!this.active) return;
      this.active = false;

      this.prev?.setAttribute('hidden', '');
      this.next?.setAttribute('hidden', '');
      this.prev?.removeEventListener('click', this.prevHandler);
      this.next?.removeEventListener('click', this.nextHandler);
      this.rail.removeEventListener('scroll', this.onScroll);

      if (this.dotsEl) {
        this.dotsEl.setAttribute('hidden', '');
        this.dotsEl.innerHTML = '';
      }
    }

    buildDots() {
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';

      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ss-commitments__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Aller à la carte ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsEl.appendChild(dot);
      });

      this.dotsEl.removeAttribute('hidden');
      this.dots = Array.from(this.dotsEl.children);
    }

    currentIndex() {
      const center = this.rail.scrollLeft + this.rail.clientWidth / 2;
      let best = 0;
      let min = Infinity;

      this.slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(slideCenter - center);
        if (dist < min) { min = dist; best = i; }
      });
      return best;
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const left = slide.offsetLeft - (this.rail.clientWidth - slide.offsetWidth) / 2;
      this.rail.scrollTo({ left, behavior: SS.reduceMotion() ? 'auto' : 'smooth' });
    }

    go(dir) {
      const next = Math.min(Math.max(this.currentIndex() + dir, 0), this.slides.length - 1);
      this.goTo(next);
    }

    update() {
      const index = this.currentIndex();
      const max = this.rail.scrollWidth - this.rail.clientWidth;

      if (this.prev) this.prev.disabled = this.rail.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.rail.scrollLeft >= max - 1;

      this.dots?.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
  });
}